/** Проверка адреса как `isEmail` в `subscription_form` монолита */
const EMAIL_PATTERN = /^.+@.+\..+$/;

export const isEmail = (value: string): boolean => EMAIL_PATTERN.test(value);
